module.exports = __webpack_public_path__ + "static/img/hnq1230.da01929.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hnq1230.jpg
// module id = Oq2J
// module chunks = 0